export const eventTypes = {
    EVENT_TYPE_ALL: "all",
    EVENT_TYPE_ACHIEVEMENT: "achievement",
    EVENT_TYPE_GRATITUDE: "points",
};